import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Slider from 'react-slick';
import moment from 'moment';
import './PropertyOfferDetail.css';
import Loader from '../../MyComponents/Loader/Loader';
import toastService from '../../../services/toastService';
import { postData } from '../../../services/apiServices';
import EditOfferModal from '../../MyComponents/EditOfferModal/EditOfferModal';
import { useSelector } from 'react-redux';
import Footer from '../../MyComponents/Footer/Footer';
import WarningAlert from '../../MyComponents/WarningAlert/WarningAlert';

const PropertyOfferDetail = () => {
    const { offerId } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [fullName, setFullName] = useState('')
    const [phone, setPhone] = useState('')
    const [images, setImages] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const userInfo = useSelector((state) => state.user.userInfo);
    const [showDeleteOfferAlert, setShowDeleteOfferAlert] = useState(false);
    const [showMarkSoldAlert, setShowMarkSoldAlert] = useState(false);
    const [isFullScreen, setIsFullScreen] = useState(false);


    const handleCancel = () => {
        setShowDeleteOfferAlert(false); // Close the alert on cancel
    };

    const handleCancelSold = () => {
        setShowMarkSoldAlert(false); // Close the alert on cancel
    };
    useEffect(() => {
        const getDetail = async () => {
            setLoading(true);
            const datas = {
                "verification_token": "123456",
                "table": "property_offers",
                "id": offerId,
            };

            try {
                const result = await axios.post('https://appvelo.com/realestateOfferAPI/get', datas);
                setLoading(false);
                console.log(result, "AD:A:D:")
                if (result?.data?.message === "success") {
                    const fetchedData = result?.data?.data[0];
                    setData(fetchedData);
                    setImages(parseImageUrls(fetchedData?.Pictures));
                    getProfileData(result?.data?.data[0]?.CreatedByID)
                } else {
                    setError("Something went wrong");
                }
            } catch (error) {
                console.error("Error: ", error);
                setLoading(false);
            }
        };

        getDetail();
    }, [offerId, navigate]);


    const getProfileData = async (id) => {
        const data = {
            verification_token: "123456",
            table: "Users",
            "id": id
        }
        try {
            const result = await postData("/get", data)
            console.log(result, "this is the profile data form the api php")
            if (result?.message === "success") {
                const mydata = result?.data[0]
                setFullName(`${mydata?.firstname} ${mydata?.lastname}`)
                setPhone(mydata?.phone)
            } else {
                toastService.showError(result?.message)


            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleDelete = async () => {


        setLoading(true);
        const datas = {
            "verification_token": "123456",
            "table": "property_offers",
            "id": offerId,
        };
        try {
            const result = await postData('/delete', datas);
            console.log(result, "this is the clicked API response");
            setLoading(false);
            if (result?.message === "success") {
                navigate('/dashboard');
                toastService.showSuccess("Property Deleted Successfully");
            } else {
                toastService.showError("Property could not be deleted");
            }
        } catch (error) {
            console.log(error, "Error");
            toastService.showError("Something went wrong");
            setLoading(false);
        }
    };

    const handleEditClick = () => {
        setIsModalOpen(true);
    };



    const parseImageUrls = (pictures) => {
        if (!pictures) return [];
        return pictures.replace(/['"]/g, '').split(',').map(url => url.trim());
    };


    const handleMarkAsSold = async (status) => {
        const action = status === "active" ? "mark this offer as sold" : "mark this offer as available";

        setLoading(true)
        const formattedImages = JSON.stringify(images).replace(/^\[|\]$/g, "");
        const datas = {
            "verification_token": "123456",
            "table": "property_offers",
            "id": data?.id,
            "offerid": data?.OfferID,
            "Area": data?.Area,
            "ContactNumber": data?.ContactNumber,
            "CreatedByID": userInfo?.id,
            "Description": data?.Description,
            "DeveloperName": data?.DeveloperName,
            "District": data?.District,
            "IsArchived": "0",
            "Location": data?.Locatoin,
            "Neighborhood": data?.Neighborhood,
            "NumberOfRooms": data?.NumberOfRooms,
            "OfferID": data?.OfferID,
            "Price": data?.Price,
            "PropertyName": data?.PropertyName,
            "PropertyStatus": data?.PropertyStatus,
            "PropertyType": data?.PropertyType,
            "Status": status,
            "isSold": status === "active" ? "0" : "1",
            "Pictures": formattedImages,
        }
        try {
            const result = await postData('/edit', datas)
            if (result?.message === "success") {
                toastService.showSuccess("Mark As Sold Successfully")
                setLoading(false)
                navigate('/dashboard');

                if (result?.data?.Status === "inactive") {
                    setLoading(false)

                }
            } else {
                toastService.showError("Offer not Edit try again")
                setLoading(false)
            }

        } catch (error) {
            console.log(error, "Error")
            setLoading(false)
            toastService.showError("Something went wrong")

        }

    };

    const handleImageClick = (image) => {
        setSelectedImage(image);
     };

    const handlefullScreen = (image) => {
         setIsFullScreen(true);  
    };
    const handleCloseFullScreen = () => {
        setIsFullScreen(false);  
    };

    return (
        <>
            <Loader isLoading={loading} />
            <h1 className='heading-top'>Details</h1>
            <div className="property-offer-detail-container">
                <div className="property-offer-detail">
                    <img src={selectedImage === null ? images[0] : selectedImage} aalt="Selected Offer" className="main-image" onClick={() => handlefullScreen(selectedImage)} />
                    <div className="thumbnail-container">
                        {images.map((image, index) => (
                            <img
                                key={index}
                                src={image}
                                alt={`Thumbnail ${index + 1}`}
                                className="thumbnail-image"
                                onClick={() => handleImageClick(image)}
                            />
                        ))}
                    </div>
                    <div className='main-detail-container'>
                        <div className='left-container'>

                            {/* left container */}
                            <h2 className='propertyName' >{data?.PropertyName}</h2>
                            <div className='location-Address-Container'>
                                <p>{data?.Location}</p>

                                <p style={{ color: data?.Status === "active" ? "green" : "red", fontSize: 17, fontWeight: 'bold' }} >{data?.Status === "active" ? "Available" : "Sold"}</p>
                            </div>

                            <div className='table-main-container'>
                                <div className='item-containers'>
                                    <p>Price</p>
                                    <h4>{data?.Price}</h4>
                                </div>

                                <div className='item-containers'>
                                    <p>Bed Rooms</p>
                                    <h4>{data?.NumberOfRooms}</h4>
                                </div>

                                <div className='item-containers'>
                                    <p>Area </p>
                                    <h4>{data?.Area} sqft</h4>
                                </div>

                                <div className='item-containers'>
                                    <p>District</p>
                                    <h4>{data?.District}</h4>
                                </div>
                            </div>

                            <div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <h2 style={{ alignSelf: 'flex-start', textAlign: 'left' }}>Description</h2>
                                    <span className={data?.PropertyStatus === "Ready" ? "status-ready" : "status-not-ready"}>
                                        {data?.PropertyStatus}
                                    </span>
                                </div>
                                <p style={{marginTop:-20}}>{data?.Description}</p>
                            </div>

                            <p><strong>Property Type:</strong> {data?.PropertyType}</p>
                            <p><strong>Contact Number:</strong> {data?.ContactNumber}</p>
                            <p><strong>Date:</strong> {moment(data?.ExpiryDate).format("ddd, MMM D, YYYY h:mm A")}</p>
                            <div className="button-container">
                                {userInfo.usertype !== "user" && (
                                    <>
                                        <button className="action-button" onClick={handleEditClick}>Edit Offer</button>
                                        <button className="action-button" onClick={() => setShowDeleteOfferAlert(true)}>Delete Offer</button>
                                        <button className="action-button" onClick={() => { setShowMarkSoldAlert(true) }}>Mark as Sold</button>
                                    </>
                                )}
                            </div>
                        </div>

                        {/* right container */}
                        <div className='right-container'>
                            <div className='user-info-container'>
                                <h2 className='posted-by-title'>Posted By</h2>
                                <h2 className='user-name'>{fullName}</h2>
                                <p className='user-phone'>{phone}</p>
                            </div>
                        </div>
                    </div>
                    {showDeleteOfferAlert && (
                        <WarningAlert
                            title="Warning!"
                            description="Are you sure you want to delete ?"
                            onConfirm={handleDelete}
                            onCancel={handleCancel}
                        />
                    )}

                    {showMarkSoldAlert && (
                        <WarningAlert
                            title="Warning!"
                            description="Are you sure you want to mark this as sold ?"
                            onConfirm={() => { handleMarkAsSold(data?.Status === "active" ? "inactive" : "active") }}
                            onCancel={handleCancelSold}
                        />
                    )}
                    {/* <div className="details">
                        {data && (
                            <>
                                <h2 className='propertyName' >{data?.PropertyName}</h2>
                                <div className='location-Address-Container'>
                                    <p>{data?.Location}</p>
                                </div>
                                <table className="property-details-table">
                                    <thead>
                                        <tr>
                                            <th>Price</th>
                                            <th>Bedrooms</th>
                                            <th>Area (sq.ft)</th>
                                            <th>Neighborhood</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>${data?.Price}</td>
                                            <td>{data?.NumberOfRooms}</td>
                                            <td>{data?.Area}</td>
                                            <td>{data?.Neighborhood}</td>
                                        </tr>
                                    </tbody>
                                </table>
 
                                 <p><strong>Description:</strong> {data?.Description}</p>
                                <p><strong>Developer Name:</strong> {data?.DeveloperName}</p>
                                <p><strong>Number of Rooms:</strong> {data?.NumberOfRooms}</p>
                                <p><strong>Area:</strong> {data?.Area} sq.ft</p>
                                <p><strong>Neighborhood:</strong> {data?.Neighborhood}</p>
                                <p>
                                    <strong>Property Status:</strong>
                                    <span className={data?.PropertyStatus === "Ready" ? "status-ready" : "status-not-ready"}>
                                        {data?.PropertyStatus}
                                    </span>
                                </p>                            <p><strong>Property Type:</strong> {data?.PropertyType}</p>
                                <p><strong>Status:</strong> {data?.Status === "active" ? "Available" : "Sold"}</p>
                                <p><strong>Contact Number:</strong> {data?.ContactNumber}</p>
                                <p><strong>Price:</strong> ${data?.Price}</p>
                                <p><strong>Date:</strong> {moment(data?.ExpiryDate).format("ddd, MMM D, YYYY h:mm A")}</p>
                            </>
                        )}
                    </div> */}

                    {/* <div className="offered-by">
                        <h3>Offered by:</h3>
                        <p><strong>Name:</strong> {fullName}</p>
                        <p><strong>Phone:</strong> {phone}</p>
                    </div>
                    <div className="button-container">
                        {userInfo.usertype !== "user" && (
                            <>
                                <button className="action-button" onClick={handleEditClick}>Edit Offer</button>
                                <button className="action-button" onClick={handleDelete}>Delete Offer</button>
                                <button className="action-button" onClick={() => { handleMarkAsSold(data?.Status === "active" ? "inactive" : "active") }}>Mark as Sold</button>
                            </>
                        )}
                    </div> */}
                </div>
                <EditOfferModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    offerId={offerId}
                    offerData={data}
                />
            </div>
            {isFullScreen && (
                <div className="full-screen-overlay" onClick={handleCloseFullScreen}>
                    <img src={selectedImage} alt="Full Screen" className="full-screen-image" />
                    <button className="close-button" onClick={handleCloseFullScreen}>X</button>
                </div>
            )}
        </>
    );
};

// Slider settings for react-slick
const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,


};



export default PropertyOfferDetail;
